import { stateKeys } from '../constants/state';

export const selectExpandedRowKeys = (state) =>
  state[stateKeys.expandedRowKeys];

export const createIsExpandedSelector = (key) => (state) =>
  state[stateKeys.expandedRowKeys]?.includes(key);
